/*
 * Achievements Messages
 *
 * This contains all the text for the Achievements container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.Achievements';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Achievements',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'total',
  },
  addAchievement: {
    id: `${scope}.addAchievement`,
    defaultMessage: 'Add Achievement',
  },
  event: {
    id: `${scope}.event`,
    defaultMessage: 'Event',
  },
  condition: {
    id: `${scope}.condition`,
    defaultMessage: 'Condition',
  },
  result: {
    id: `${scope}.result`,
    defaultMessage: 'Result',
  },
  percentage: {
    id: `${scope}.percentage`,
    defaultMessage: 'WR %',
  },
  startDate: {
    id: `${scope}.startDate`,
    defaultMessage: 'Start date',
  },
  endDate: {
    id: `${scope}.endDate`,
    defaultMessage: 'End date',
  },
  confirmedBy: {
    id: `${scope}.confirmedBy`,
    defaultMessage: 'Confirmed by',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  pending: {
    id: `${scope}.pending`,
    defaultMessage: 'Pending',
  },
  confirmed: {
    id: `${scope}.confirmed`,
    defaultMessage: 'Confirmed',
  },
  declined: {
    id: `${scope}.declined`,
    defaultMessage: 'Declined',
  },
  achievementDetails: {
    id: `${scope}.achievementDetails`,
    defaultMessage: 'Achievement Details',
  },
  deleteAchievement: {
    id: `${scope}.deleteAchievement`,
    defaultMessage:
        'Are you sure you want to delete this Achievement?',
  },
});
